if (!customElements.get("td-collection-header-filter")) {
  class TDCollectionHeaderFilter extends HTMLElement {
    constructor() {
      super();
      this.toggleSwitch = null;
      this.toggleSlider = null;
      this.toggleLabels = null;
      this.buttonWrappers = null;
    }

    connectedCallback() {
      this.toggleSwitch = this.querySelector('.td-chf__toggle-switch');
      this.toggleSlider = this.querySelector('.td-chf__toggle-slider');
      this.toggleLabels = this.querySelectorAll('.td-chf__toggle-label');
      this.buttonWrappers = this.querySelectorAll('.td-chf__buttons-wrapper');

      // Determine initial active list from data
      let initialActive = 1;
      if (this.buttonWrappers[1] && this.buttonWrappers[1].classList.contains('td-chf__buttons-wrapper--active')) {
        initialActive = 2;
      }
      this.setActive(initialActive);

      // Add click handlers
      this.toggleSlider.addEventListener('click', () => {
        this.setActive(this.toggleSwitch.getAttribute('data-active') === '1' ? 2 : 1);
      });
      this.toggleLabels.forEach(label => {
        label.addEventListener('click', () => {
          this.setActive(label.getAttribute('data-list'));
        });
      });
    }

    setActive(listNumber) {
      listNumber = parseInt(listNumber);
      if (!this.toggleSwitch || !this.buttonWrappers) return;
      this.toggleSwitch.setAttribute('data-active', listNumber);
      // Update aria-selected for a11y
      this.toggleLabels.forEach(label => {
        label.setAttribute('aria-selected', label.getAttribute('data-list') == listNumber);
      });
      // Update button wrappers
      this.buttonWrappers.forEach(wrapper => {
        const isActive = wrapper.getAttribute('data-list') == listNumber;
        wrapper.classList.toggle('td-chf__buttons-wrapper--active', isActive);
      });
    }
  }

  customElements.define("td-collection-header-filter", TDCollectionHeaderFilter);
} 